import {SettingsParamsType} from '../../types/createStylesParams'
import {
  formSettingsParams,
  FormSettingsParams,
} from '../../components-shared/Settings/FormDesign/settingsParams'

import {textsSettingsParams, TextsSettingsParams} from './Settings/Tabs/Texts/settingsParams'
import {DisplaySettingsParams, displaySettingsParams} from './Settings/Tabs/Display/settingsParams'

export type SettingsParams = FormSettingsParams & TextsSettingsParams & DisplaySettingsParams

export const settingsParams: SettingsParamsType<SettingsParams> = {
  ...formSettingsParams,
  ...textsSettingsParams,
  ...displaySettingsParams,
}

export default settingsParams
